export const paymentEsLocale = {
  'checkout.payment.title': 'Información de pago',
  'checkout.payment.description': 'Usa tarjeta de crédito o débito',
  'checkout.payment.addCard': 'Agregar tarjeta',
  'checkout.payment.cardHolderName': 'Nombre de titular de la tarjeta',
  'checkout.payment.cardHolderLastName': 'Apellido de titular de la tarjeta',
  'checkout.payment.cardNumber': 'Número de tarjeta',
  'checkout.payment.expiration': 'Fecha de expiración',
  'checkout.payment.cvv': 'Código de seguridad',
  'checkout.payment.cvvHelp':
    'Últimos 3 o 4 dígitos en el reverso de la tarjeta (al frentepara American Express)',
  'checkout.payment.address': 'Dirección de facturación',
  'checkout.payment.state': 'Estado',
  'checkout.payment.city': 'Ciudad',
  'checkout.payment.zip': 'Código postal',
  'checkout.payment.phone': 'Teléfono',
  'checkout.payment.saveCard': 'Guardar tarjeta para futuras compras.',
  'checkout.payment.noRefund':
    'Acepto que todas las compras son finales y no hay reembolsos.',
  'checkout.payment.privacy': 'Privacidad y seguridad',
  'checkout.payment.confirm': 'Completar orden',
  'checkout.payment.enterCode': 'Ingresa el código',
  'checkout.payment.installments': 'Cuotas',
  'checkout.payment.enterCardHolderName':
    'Ingrese el nombre del titular de la tarjeta',
  'checkout.payment.enterCardHolderLastName':
    'Ingrese el apellido del titular de la tarjeta',
  'checkout.payment.enterCardNumber': 'Ingrese el número de tarjeta',
  'checkout.payment.invalidCardNumber': 'Número de tarjeta inválido',
  'checkout.payment.enterExpiration': 'Ingrese la fecha de expiración',
  'checkout.payment.invalidExpiration': 'Fecha de expiración inválida',
  'checkout.payment.enterCvv': 'Ingrese el código de seguridad',
  'checkout.payment.phoneRequired': 'Por favor, ingrese su número de teléfono',
  'checkout.payment.addressRequired': 'Por favor, ingrese su dirección',

  'checkout.payment.or': 'O paga con',

  'checkout.payment.terms':
    'Al usar cualquiera de los métodos de pago, aceptas nuestros',
  'checkout.payment.termsLink': 'Términos y condiciones',

  'checkout.payment.addCode': 'Códigos Promocionales',
  'checkout.payment.addPromoCode': 'Aplicar',
  'checkout.payment.promoApplied': 'Código aplicado',

  'checkout.payment.payWithCard': 'Cobrar con tarjeta',
  'checkout.payment.payWithCash': 'Cobrar en efectivo',

  'checkout.payment.procesing': 'Procesando pago...',
  'checkout.payment.success': 'Pago exitoso',
  'checkout.payment.applyingPromo': 'Aplicando código promocional...',
  'checkout.payment.promoInvalid':
    'Lo sentimos, el código de promoción ingresado NO ha generado ningún descuento. Consultar condiciones para saber cómo debe aplicarse y/o si aún es vigente.',
  'checkout.payment.promoSuccess': 'Código promocional aplicado con éxito',

  'checkout.payment.back': 'Volver',

  'checkout.payment.validatingCard': 'Validando tarjeta...',
  'checkout.payment.cardPromoInvalid':
    'La tarjeta no aplica para descuento, puedes continuar con el pago',
  'checkout.payment.cardPromo': 'Descuento de tarjeta aplicado con éxito',
  'checkout.payment.cardValid': 'Tarjeta válida, puedes continuar con el pago',

  'checkout.payment.cardError':
    'Por favor, verifica los datos de tu tarjeta e intenta de nuevo',
  'checkout.payment.tryAgain':
    'Por favor, verifica los datos de tu tarjeta e intenta de nuevo',
  'checkout.payment.retry': 'Intentar de nuevo',

  'checkout.payment.changingMethod': 'Cambiando método de pago...',
  'checkout.payment.methodChanged': 'Método de pago cambiado con éxito',
  'checkout.payment.methodError': 'Error al cambiar método de pago',
  'checkout.payment.emailRequired': 'Por favor, ingresa tu correo electrónico',
  'checkout.payment.invalidEmail': 'Correo electrónico inválido',
  'checkout.payment.email': 'Correo electrónico',
  'checkout.payment.confirmEmail': 'Confirmar correo electrónico',
  'checkout.payment.emailMatch': 'Los correos no coinciden',

  'checkout.payment.identityDocument': 'Documento de identidad',
  'checkout.payment.passport': 'Pasaporte',

  'checkout.payment.required.terms': 'Debes aceptar los términos y condiciones',
  'checkout.payment.confirmarCompra':
    'Confirmo que la fecha, hora y los tickets seleccionados son correctos',
  'checkout.payment.required.confirmarCompra':
    'Debes confirmar que la fecha, hora y los tickets seleccionados son correctos',
} as const;

export const paymentEnLocale = {
  'checkout.payment.title': 'Payment information',
  'checkout.payment.description': 'Use credit or debit card',
  'checkout.payment.addCard': 'Add a card',
  'checkout.payment.cardHolderName': 'Cardholder name',
  'checkout.payment.cardHolderLastName': 'Cardholder last name',
  'checkout.payment.cardNumber': 'Card Number',
  'checkout.payment.expiration': 'Expiration Date',
  'checkout.payment.cvv': 'Security code',
  'checkout.payment.cvvHelp':
    'Last 3 or 4 digits on the back of the card (front for American Express)',
  'checkout.payment.address': 'Billing address',
  'checkout.payment.state': 'State',
  'checkout.payment.city': 'City',
  'checkout.payment.zip': 'Zip code',
  'checkout.payment.phone': 'Phone',
  'checkout.payment.saveCard': 'Save card for future purchases',
  'checkout.payment.privacy': 'Privacy and Security',
  'checkout.payment.noRefund':
    'I accept that all purchases are final and non-refundable',

  'checkout.payment.confirm': 'Place Order',
  'checkout.payment.enterCode': 'Enter Code',
  'checkout.payment.installments': 'Installments',

  'checkout.payment.enterCardHolderName': 'Enter cardholder name',
  'checkout.payment.enterCardHolderLastName': 'Enter cardholder last name',
  'checkout.payment.enterCardNumber': 'Enter card number',
  'checkout.payment.invalidCardNumber': 'Invalid card number',
  'checkout.payment.enterExpiration': 'Enter expiration date',
  'checkout.payment.invalidExpiration': 'Invalid expiration date',
  'checkout.payment.enterCvv': 'Enter security code',
  'checkout.payment.phoneRequired': 'Please enter your phone number',
  'checkout.payment.addressRequired': 'Please enter your address',

  'checkout.payment.or': 'Or pay with',

  'checkout.payment.terms':
    'By using any of the payment methods, you agree to our',
  'checkout.payment.termsLink': 'Terms and Conditions',

  'checkout.payment.addCode': 'Promotional Codes',
  'checkout.payment.addPromoCode': 'Apply',
  'checkout.payment.promoApplied': 'Code applied',

  'checkout.payment.payWithCard': 'Charge with card',
  'checkout.payment.payWithCash': 'Charge in cash',

  'checkout.payment.procesing': 'Processing payment...',
  'checkout.payment.success': 'Successful payment',
  'checkout.payment.applyingPromo': 'Applying promotional code...',
  'checkout.payment.promoInvalid': 'Promotional code is invalid',
  'checkout.payment.promoSuccess': 'Promotional code applied successfully',

  'checkout.payment.back': 'Back',

  'checkout.payment.validatingCard': 'Validating card...',
  'checkout.payment.cardPromoInvalid':
    'The card does not apply for discount, you can continue with the payment',
  'checkout.payment.cardPromo': 'Card discount applied successfully',
  'checkout.payment.cardValid': 'Valid card, you can continue with the payment',

  'checkout.payment.cardError': 'Please verify your card details and try again',
  'checkout.payment.tryAgain': 'Please verify your card details and try again',
  'checkout.payment.retry': 'Retry',

  'checkout.payment.changingMethod': 'Changing payment method...',
  'checkout.payment.methodChanged': 'Payment method changed successfully',
  'checkout.payment.methodError': 'Error changing payment method',
  'checkout.payment.emailRequired': 'Please enter your email',
  'checkout.payment.invalidEmail': 'Invalid email',
  'checkout.payment.email': 'Email',
  'checkout.payment.confirmEmail': 'Confirm email',
  'checkout.payment.emailMatch': 'Emails do not match',

  'checkout.payment.identityDocument': 'Identity document',
  'checkout.payment.passport': 'Passport',

  'checkout.payment.required.terms': 'You must accept the terms and conditions',
  'checkout.payment.confirmarCompra':
    'I confirm that the date, time, and selected tickets are correct',
  'checkout.payment.required.confirmarCompra':
    'You must confirm that the date, time, and selected tickets are correct',
} as const;
